import { create } from 'zustand';
import { ModalContextType, RouteBuilderFilterType } from '@lp/features/RoutePlanner/types';
import { createSelectors } from '@/utils/helpers';

type RouteBuilderState = {
  // General
  resetStore: () => void;

  // Map filters
  filters: RouteBuilderFilterType | null;
  setFilters: (filters: RouteBuilderFilterType) => void;
  updateFilters: (
    filter: RouteBuilderFilterType[keyof RouteBuilderFilterType],
    type: keyof RouteBuilderFilterType,
  ) => void;

  // Modals
  modal: ModalContextType;
  isModalLoading: boolean;
  isModalOpen: boolean;
  handleOpenModal: (context: ModalContextType) => void;
  handleCloseModal: () => void;
  setModalLoading: (bool: boolean) => void;
  isActionLoading: boolean;
  setActionLoading: (bool: boolean) => void;
};

const createDefaultState = () => ({
  filters: null,
  modal: {
    type: null,
    context: null,
  },
  isModalLoading: false,
  isModalOpen: false,
  isActionLoading: false,
});

const useRouteBuilderBaseState = create<RouteBuilderState>()((set, get) => ({
  ...createDefaultState(),
  // General
  resetStore: () => set(createDefaultState()),

  // Map Filters
  setFilters: (filters) => set({ filters }),
  updateFilters: (filter, type) => {
    const prevFilters = get().filters;
    if (!type || !prevFilters) return;

    set({
      filters: {
        ...prevFilters,
        [type]: filter,
      },
    });
  },
  // Modals
  setModalLoading: (bool) => set({ isModalLoading: bool }),
  handleCloseModal: () =>
    set({
      modal: { type: null, context: null },
      isModalOpen: false,
    }),
  handleOpenModal: (context) => {
    set({
      modal: context,
      isModalOpen: true,
    });
  },
  // Actions
  setActionLoading: (bool) => set({ isActionLoading: bool }),
}));

export const useRouteBuilderState = createSelectors(useRouteBuilderBaseState);
